import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=604f03c8&scoped=true&"
import script from "./table-list.vue?vue&type=script&lang=js&"
export * from "./table-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604f03c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('604f03c8')) {
      api.createRecord('604f03c8', component.options)
    } else {
      api.reload('604f03c8', component.options)
    }
    module.hot.accept("./table-list.vue?vue&type=template&id=604f03c8&scoped=true&", function () {
      api.rerender('604f03c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/supplier-dynamic-data/modules/table-list.vue"
export default component.exports